import { PrefetchLink } from "~/features/products/ProductCard/PrefetchingLink";
import { Content } from "~/features/products/ProductCard/parts/Content";
import { Description } from "~/features/products/ProductCard/parts/Description";
import { Gallery } from "~/features/products/ProductCard/parts/Gallery";
import { InlineContent } from "~/features/products/ProductCard/parts/InlineContent";
import { MinimumPrice } from "~/features/products/ProductCard/parts/MinimumPrice";
import { Name } from "~/features/products/ProductCard/parts/Name";
import { Price } from "~/features/products/ProductCard/parts/Price";
import { Tags } from "~/features/products/ProductCard/parts/Tags/Tags";
import { YarnWidget } from "~/features/products/ProductCard/parts/YarnWidget";
import styles from "./ProductCard.module.css";

const Card = ({ slug, name, children, ...props }: Props) => {
	return (
		<PrefetchLink
			href={`${slug}`}
			aria-label={name}
			data-product-card
			className={styles["product-card"]}
			{...props}
			prefetch={false}
		>
			{children}
		</PrefetchLink>
	);
};

export const PC = {
	Card,
	Gallery: Gallery,
	Tags,
	Inline: InlineContent,
	YarnWidget,
	Content,
	Description,
	Price,
	MinimumPrice,
	Name,
};

type Props = {
	slug: string;
	name: string;
	children: CompundProps;
} & Omit<React.HTMLAttributes<HTMLAnchorElement>, "href" | "aria-label" | "className">;

type Compounds =
	| typeof PC.Gallery
	| typeof PC.Content
	| typeof PC.Description
	| typeof PC.Tags
	| typeof PC.Inline
	| typeof PC.YarnWidget
	| typeof PC.Price
	| typeof PC.MinimumPrice
	| typeof PC.Name;

type CompundProps =
	| React.ReactComponentElement<Compounds>
	| React.ReactComponentElement<Compounds>[]
	| string;

export interface ProductCard__Image {
	url: string;
	alt: string;
}
